import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/Tooltip'
import { cn } from '@/lib/cn'
import type { Assignee } from '../../types'

/**
 * 24px circle showing the assignee's initials, or a dashed-border empty
 * circle when unassigned. The dashed empty state is faster to scan than
 * "—" or whitespace because the eye reads it as a placeholder shape.
 */
export function AssigneeAvatar({ assignee }: { assignee: Assignee | null }) {
  if (!assignee) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            aria-label="Unassigned"
            className="inline-block h-6 w-6 rounded-full border border-dashed border-border"
          />
        </TooltipTrigger>
        <TooltipContent>Unassigned</TooltipContent>
      </Tooltip>
    )
  }
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          aria-label={`Assigned to ${assignee.display_name}`}
          className={cn(
            'inline-flex h-6 w-6 items-center justify-center rounded-full bg-muted text-[0.625rem] font-semibold uppercase text-muted-fg',
          )}
        >
          {assignee.initials}
        </span>
      </TooltipTrigger>
      <TooltipContent>{assignee.display_name}</TooltipContent>
    </Tooltip>
  )
}
